var map = {
	"./JILI.png": "cfa5",
	"./OTHER.png": "79fc",
	"./PG.png": "581e",
	"./PP.png": "320b",
	"./logo/slot_gamex_jili.png": "1495",
	"./logo/slot_gamex_other.png": "6281",
	"./logo/slot_gamex_pg.png": "5c01",
	"./logo/slot_gamex_pp.png": "f357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08d1";